// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"89cc71f5","832":"0d903e10"}[chunkId] + ".chunk.js";
};